<!-- components/ModalAlert.vue -->
<template>
  <ClientOnly>
    <Teleport to="body">
      <div v-if="isVisible" class="modal-popup">
        <div class="dimm3 open" @click="handleOverlayClick"></div>
        <div class="modal_popup_wrapper open">
          <div class="modal_popup_inner">
            <!-- <div style="width: 100%; text-align: right">
          <button class="bp_close2" @click="$emit('update:isShow', false)">
            <img src="@/assets/images/close_ico.png" alt="" />
          </button>
        </div> -->
            <div class="popup_header" v-if="modalOptions.title">
              <p class="hl1" v-html="modalOptions.title"></p>
            </div>
            <div class="popup_inner" v-if="modalOptions.message">
              <p class="hl3 g400" v-html="modalOptions.message"></p>
            </div>
          </div>

          <div class="confirm_2btn_wrapper">
            <button class="left" v-if="modalOptions.type === 'confirm'" @click="handleCancel">
              {{ modalOptions.cancelText || "취소" }}
            </button>
            <button class="confirm_btn btn_on" @click="handleConfirm">
              {{ modalOptions.confirmText || "확인" }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </ClientOnly>
</template>

<script setup>
import { computed, onMounted, onUnmounted } from "vue";
import { useModalStore } from "../stores/modal";

const modalStore = useModalStore();

const modalOptions = computed(() => modalStore.modalAlertOptions || {});
const isVisible = computed(() => modalStore.isModalVisible || false);

const handleConfirm = () => {
  modalStore.confirmModal();
};

const handleCancel = () => {
  modalStore.cancelModal();
};

const handleOverlayClick = (event) => {
  console.log(event.target);
  console.log(event.currentTarget);
  console.log(modalOptions.value.type);
  // confirm 모달이 아닌 경우에만 오버레이 클릭으로 닫기
  if (event.target === event.currentTarget) {
    if (modalOptions.value.type !== "confirm") {
      modalStore.closeModalAlert();
    }
  }
};

// ESC 키로 모달 닫기
const handleKeydown = (event) => {
  if (event.key === "Escape") {
    if (modalOptions.value.type === "confirm") {
      handleCancel();
    } else {
      modalStore.closeModalAlert();
    }
  }
};

onMounted(() => {
  document.addEventListener("keydown", handleKeydown);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeydown);
});
</script>

<style scoped>
/* ConfirmPopup 스타일과 동일하게 유지 */
/* 기존 프로젝트의 CSS를 사용하므로 별도 스타일 불필요 */
</style>
